
export const AnswerUtils = {
    validateAnswerRequest (answer) {
        if (answer) {
            const keys = Object.getOwnPropertyNames(answer)
            if (keys.indexOf('quizKey') === -1) {
                throw new Error('Missing quizKey attribute on answer object')
            }
            if (keys.indexOf('questionKey') === -1) {
                throw new Error('Missing questionKey attribute on answer object')
            }
            if (keys.indexOf('answer') === -1) {
                throw new Error('Missing answer attribute on answer object')
            }
            if (keys.indexOf('timeLeft') === -1) {
                throw new Error('Missing timeLeft attribute on answer object')
            }
        } else {
            throw new Error('no answer object')
        }
    },

    validateTurnInAnswersRequest (turnInAnswersRequest) {
        if (turnInAnswersRequest) {
            if (!turnInAnswersRequest.name) {
                throw new Error('Missing name attribute on request object')
            }
            if (!turnInAnswersRequest.quizKey) {
                throw new Error('Missing quizKey attribute on request object')
            }
            if (!turnInAnswersRequest.bonusType) {
                throw new Error('Missing bonusType attribute on request object')
            }
            if (turnInAnswersRequest.answers && Array.isArray(turnInAnswersRequest.answers)) {
                for (let answer of turnInAnswersRequest.answers) {
                    const keys = Object.getOwnPropertyNames(answer)
                    if (keys.indexOf('questionKey') === -1) {
                        throw new Error('Missing questionKey attribute on answer object')
                    }
                    if (keys.indexOf('multiplier') === -1) {
                        throw new Error('Missing multiplier attribute on answer object')
                    }
                    if (keys.indexOf('wildCard') === -1) {
                        throw new Error('Missing wildCard attribute on answer object')
                    }
                }
            } else {
                throw new Error('Not an array')
            }
        } else {
            throw new Error('no request object')
        }
    }
}
